'use client'

import { Box } from '@mui/material'
import { Image } from '@media-components'
import { EnquiryForm, SectionWrapper } from '@components/common'
import { CustomStyles, getStyles } from '@utils/styles'
import defaultStyles, { StyleClassNames } from './styles'

export type Props = {
  csx?: CustomStyles<StyleClassNames>
  hideMedia?: boolean
}

export function EnquirySection({ hideMedia = false, csx }: Props) {
  const styles = getStyles(defaultStyles, csx)

  const imageData = {
    src: '/images/contact-us.webp',
    alt: 'img',
  }

  return (
    <SectionWrapper
      csx={{
        wrapper: styles('sectionWrapper').sx,
      }}
    >
      <Box
        sx={{
          display: 'flex',
          gap: '40px',
          flexDirection: { xs: 'column', md: 'row' },
        }}
      >
        {!hideMedia && (
          <Box {...styles('imageContainer')}>
            <Image {...imageData} {...styles('image')} />
          </Box>
        )}
        <EnquiryForm
          csx={{
            wrapper: { maxWidth: { xs: 'unset', md: 'calc(100% - 40px)' } },
          }}
          formType="QueryBudget"
        />
      </Box>
    </SectionWrapper>
  )
}
